import { AccountDatasource } from '../datasources/account_datasource';
import { AccountServant } from '../servants/account_servant';

angular.module('capability-ng-user-app').config(function($httpProvider: ng.IHttpProvider): void {
  $httpProvider.interceptors.push(function(
    ngAccountServant: AccountServant,
    ngAccountDatasource: AccountDatasource
  ): ng.IHttpInterceptor {
    return {
      request(httpConfiguration: ng.IRequestConfig): ng.IRequestConfig {
        httpConfiguration = ngAccountServant.constructNetworkAuthenticationHeader(
          ngAccountDatasource.read(),
          httpConfiguration
        );
        return httpConfiguration;
      }
    };
  });
});



// WEBPACK FOOTER //
// ./app/lib/user_app/configuration/include_authentication_header_interceptor.ts